import wretch from 'wretch';
import { readRemoteConfigBoolean } from '@loggi/firebase-feature-switches';
import { releaseTag } from '../../../../package.json';
import { featureSwitches } from '../../feature-switches';
import { parserErrorFromApi } from './index';
import {
  authMiddleware,
  intercept401Middleware,
  intercept403Middleware,
  intercept410Middleware,
  intercept426Middleware
} from './middlewares';

export function isDriverBffEnabled() {
  if (!process.env.REACT_APP_DRIVER_BFF_URL) return false;
  return readRemoteConfigBoolean(featureSwitches.enableDriverBff) !== false;
}

export default function apiDriverBff() {
  return wretch()
    .url(process.env.REACT_APP_DRIVER_BFF_URL)
    .headers({
      appVersion: process.env.REACT_APP_VERSION || releaseTag,
      service: 'flecha'
    })
    .middlewares(
      [
        authMiddleware,
        intercept401Middleware,
        intercept410Middleware,
        intercept403Middleware,
        intercept426Middleware
      ],
      true
    )
    .errorType('json');
}

export function getDriverBff(endpoint) {
  return apiDriverBff()
    .url(endpoint)
    .get()
    .fetchError(err => {
      const error = new Error(err?.message || '');
      error.isFetchError = true;
      throw error;
    })
    .json()
    .catch(err => {
      if (err.status) {
        throw parserErrorFromApi(err);
      }
      throw err;
    });
}
